<template>
  <div class="index"> 
    <TableLayout>
      <template slot="search-form">
        <tab-button
          :tabs="questionType"
          :label="'题目类型'"
          :prop="'type'"
          :initialTab="null"
          @tab-change="onTabChange"
        />
        <tab-button
          :tabs="questionLevel"
          :prop="'level'"
          :label="'题目难度'"
          :initialTab="null"
          @tab-change="onTabChange"
        />
        <section class="btn-actions">
          <div class="fl">
            <el-form ref="searchForm" @submit.native.prevent slot="search-form" :model="searchForm" label-width="86px" inline>
              <el-form-item label="课程目录" prop="directoryId">
                <el-cascader ref="cascader" :popper-append-to-body="false" popper-class="custom-dropdown"
                  v-model="searchForm.directoryId" size="medium"
                  :show-all-levels="false" clearable filterable
                  :props="props" :options="directoryList"
                  @change="handleChange"
                  ></el-cascader>
              </el-form-item>
              <el-form-item label="关键字" prop="questionKey">
                <el-input v-model="searchForm.questionKey" placeholder="请输入" @keyup.enter.native="keyDownEnter" clearable size="medium" class="item-width"></el-input>
              </el-form-item>
              <section  style="">
                <div class="search-btn" @click="search()" >搜索</div>
                <!-- <el-button
                  size="small"
                  type="primary"
                  @click="search()"
                >搜索</el-button> -->
              </section>
            </el-form>
          </div>
          <div class="fr">
            <el-button icon="el-icon-upload" size="small" type="primary" @click="multipleAdd">批量录题</el-button>
            <el-button icon="el-icon-edit" type="text" @click="handleAdd">新增试题</el-button>
          </div>
        </section>
      </template>
      <!-- 表格和分页 :height="tableHeight - (showObj ? 34 : 0)" -->
      <template slot="table-wrap">
        <el-table
          ref="tableList":height="tableHeight"
          :row-style="selectedstyle"
          :row-class-name="tableRowClassName"
          :header-cell-style="{background:'#1e87f1', color:'#fff'}"
          v-loading="isWorking.loading"
          :data="tableData.list"
        >
          <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
          <el-table-column prop="type" label="题目类型" :formatter="this.formatterType" align="center"></el-table-column>
          <el-table-column prop="level" label="题目难度" :formatter="this.formatterLevel" align="center"></el-table-column>
          <el-table-column prop="directoryLevel" label="小节序号" width="100" align="center"></el-table-column>
          <el-table-column prop="directoryName" label="课程目录" min-width="180px" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="questionKey" label="关键字" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" min-width="200px" align="center"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="handleLook(row)">查看详情</el-button>
              <el-button type="text" @click="handleEdit(row)">编辑</el-button>
              <el-button type="text" class="delete" @click="handleDel(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="fix-footer">
        <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange($event)"
          :pagination="tableData.pagination"
        ></pagination>
        </div>
      </template>
    </TableLayout>
    <Dialog class="multiple-addquestion-dialog"
      v-model="dialogVisible" :width="'80%'" :top="'40px'"
      :title="'批量录题'" :footer="false"
    >
      <template slot="dialog-content">
        <MultipleAddquestion ref="MultipleAddquestion" />
      </template>
    </Dialog>
    <Dialog class="detail-dialog"
      v-model="dialogdetail" :width="'80%'" :top="'40px'"
      :title="'查看详情'" :footer="false"
      @confirm="handleConfirm"
    >
      <template slot="dialog-content">
        <questiondetail  ref="questiondetail" />
      </template>
    </Dialog>
    
  </div>
</template>

<script>
import { comMethod } from '@/utils/index.js'
import { questionType, questionLevel } from '@/data/data';
import tabButton from '@/mixin/tabButton.js';
import formatter from '@/mixin/formatter.js';
import TableLayout from '@/layout/TableLayout'
import BaseTable from '@/components/BaseTable'
import Pagination from '@/components/common/pagination'
import Dialog from '@/components/common/Dialog';
import MultipleAddquestion from './page/MultipleAddquestion.vue';
import questiondetail from './details/questiondetail.vue'
import { questionServer, courseServer } from '@/api/api'
export default {
  name: 'question',
  extends: BaseTable,
  mixins: [tabButton, formatter],
  components: {TableLayout, Pagination, Dialog, MultipleAddquestion, questiondetail},
  data () {
    return {
      tableHeight: 300,
      questionType,
      questionLevel,
      directoryList: [],
      searchForm: {
        type: null,
        level: null,
        directoryId: null,
        questionKey: null
      },
      dialogVisible: false, // 控制弹窗的显示与隐藏（批量上传）
      dialogdetail: false,
      isCollectArr: []
    }
  },
  methods: {
    keyDownEnter (e) {
      e.preventDefault(); // 阻止事件默认行为
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 13) {
        this. this.search();// 搜索按钮的回调
      }
    },
    /**
     * 页码变更处理
     * @function handlePageChange
     * @param { Interger } pageIndex 搜索页面
     * @param { Object } obj 搜索处理逻辑内容
     */
    handlePageChange (pageIndex, obj = {}) {
      this.isWorking.loading = true
      this.tableData.pagination.pageIndex = pageIndex
      questionServer.questionList({
        ...this.searchForm,
        page: pageIndex,
        rows: this.tableData.pagination.pageSize
      }).then(res => {
        this.isWorking.loading = false
        let { code, data, message } = res
        if (code === '0') {
          if (data) {
            this.tableData.list = data.records
            this.tableData.pagination.total = data.total || 0
          }
        } else {
          this.$message.error(message)
        }
      }).finally(() => {
        this.isWorking.loading = false
      })
    },
    handleAdd () {
      let rourteUrl = this.$router.resolve({
        path: 'addquestionIndex'
      });
      window.open(rourteUrl.href, '_blank')
    },
    handleLook (row) {
      this.rowIndex = row.index;
      this.dialogdetail = true
      this.$nextTick(() => {
        this.$refs.questiondetail.getDetail(row.id)
      })
    },
    handleEdit (row) {
      this.rowIndex = row.index;
      let rourteUrl = this.$router.resolve({
        path: 'addquestionIndex',
        query: {id: row.id}
      });
      window.open(rourteUrl.href, '_blank')
    },
    handleDel (row) {
      let str = '确定要删除吗？'
      this.$confirm(str, '提示', { type: 'warning' }).then(() => {
        questionServer.questionDel({
          id: row.id
        }).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功');
            this.search()
          } else {
            this.$alert(res.message, '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true
            });
          }
        }).catch((error) => {
          this.$message.error(error)
        })
      })
    },
    // 处理 tab 切换事件
    onTabChange({tab, prop}) {
      this.searchForm[prop] = tab
      this.search()
    },
    // 打开弹窗
    multipleAdd() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.MultipleAddquestion.init()
      })
    },
    // 弹窗确认的回调
    handleConfirm() {
      this.dialogdetail = false
      // this.$message.success('操作成功！');
    },
    // 课程目录
    selectData () {
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.INITData(data)
          this.directoryList = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    INITData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].subList.length < 1) {
          data[i].subList = undefined // subList若为空数组，则将subList设为undefined
        } else {
          this.INITData(data[i].subList) // subList若不为空数组，则继续 递归调用 本方法
        }
      }
    },
    handleChange(value) {
      // 手动收起下拉框
      this.$nextTick(() => {
        this.$refs.cascader.dropDownVisible = false; // 收起下拉框
      })
      this.handlePageChange(1);
    },
    keyDownEnter (e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 13) {
        this.search();// 搜索按钮的回调
      }
    }
  },
  mounted () {
    this.selectData()
    this.search()
  },
  created () {
    this.tableHeight = comMethod.getTableHeight(290)
  }
}
</script>
<style lang='scss'>
.multiple-addquestion-dialog .common-dialog-box.el-dialog {
  height: auto;
}
.detail-dialog {
  .common-dialog-box.el-dialog {
    height: auto;
  }
}
</style>
<style scoped lang='scss'>
.index .btn-actions {
  .search-btn {
    display: inline-block;
    width: 60px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #D0DFFB;
    color: #0052D9;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 30px;
    margin-left: 2px;
    text-align: center;
    // &:hover {
    //   background: #0052D9;
    //   border: 1px solid #0052D9;
    //   color: #fff;
    // }
  }
  /deep/ .el-input__inner {
    font-family: PingFang SC;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #D0DFFB;
    // color: #AAB4D2;
  }
  /deep/ .el-select, /deep/ .el-cascader {
    .el-input__inner {
      width: 160px;
      border-radius: 4px;
      color: #4F6389;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/resource/question.vue